import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/documentNode';
import * as Apollo from '@apollo/client';
export const MemberHomeProfileTabUpdateProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MemberHomeProfileTabUpdateProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"profile"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MemberProfileFields"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMemberProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"profile"},"value":{"kind":"Variable","name":{"kind":"Name","value":"profile"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bio"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"MemberHomeProfileTabUpdateProfile","document":MemberHomeProfileTabUpdateProfileDocument}} as const;
export type MemberHomeProfileTabUpdateProfileMutationVariables = Types.Exact<{
  profile: Types.MemberProfileFields;
}>;


export type MemberHomeProfileTabUpdateProfileMutation = (
  { __typename: 'Mutation' }
  & { updateMemberProfile?: Types.Maybe<(
    { __typename: 'Member' }
    & Pick<Types.Member, 'id' | 'bio' | 'username'>
  )> }
);

export type MemberHomeProfileTabUpdateProfileMutationFn =
  Apollo.MutationFunction<
    MemberHomeProfileTabUpdateProfileMutation,
    MemberHomeProfileTabUpdateProfileMutationVariables
  >;

/**
 * __useMemberHomeProfileTabUpdateProfileMutation__
 *
 * To run a mutation, you first call `useMemberHomeProfileTabUpdateProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMemberHomeProfileTabUpdateProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [memberHomeProfileTabUpdateProfileMutation, { data, loading, error }] = useMemberHomeProfileTabUpdateProfileMutation({
 *   variables: {
 *      profile: // value for 'profile'
 *   },
 * });
 */
export function useMemberHomeProfileTabUpdateProfileMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MemberHomeProfileTabUpdateProfileMutation,
    MemberHomeProfileTabUpdateProfileMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    MemberHomeProfileTabUpdateProfileMutation,
    MemberHomeProfileTabUpdateProfileMutationVariables
  >(MemberHomeProfileTabUpdateProfileDocument, options);
}
export type MemberHomeProfileTabUpdateProfileMutationHookResult = ReturnType<
  typeof useMemberHomeProfileTabUpdateProfileMutation
>;
export type MemberHomeProfileTabUpdateProfileMutationResult =
  Apollo.MutationResult<MemberHomeProfileTabUpdateProfileMutation>;
export type MemberHomeProfileTabUpdateProfileMutationOptions =
  Apollo.BaseMutationOptions<
    MemberHomeProfileTabUpdateProfileMutation,
    MemberHomeProfileTabUpdateProfileMutationVariables
  >;
